<template>
  <div 
    :class="classList"
    class="Tags">
    <Tag 
      v-for="tag in visibleTags" 
      :key="tag.name" 
      :label="tag.name" 
      :type="tag.type"
      :slug="tag.slug" 
      :compact="compact" />
  </div>
</template>

<script>
import Tag from './Tag';

export default {
  name: 'Tags',
  components: {
    Tag
  },
  props: {
    tags: {
      type: Array,
      required: true
    },
    compact: {
      type: Boolean,
      default: false
    },
    limit: {
      type: Number,
      default: 0
    }
  },
  computed: {
    classList() {
      return {
        'Tags--compact' : this.compact
      }
    },
    visibleTags() {
      return this.limit === 0 
        ? this.tags 
        : this.tags.slice(0, this.limit);
    }
  }
}
</script>

<style lang="scss">
  .Tags {
    margin: 32px;
    display: flex;
    flex-wrap: wrap;

    &--compact {
      display: inline-block;
      margin: 0;

      .Tag {
        display: inline-block;
        margin-right: 8px;
        margin-bottom: 12px;

        &:not(:last-child) {
          &:after {
            content: ',';
          }
        }
      }
    }
  }
</style>
